const styles = {
    container: {
        width: '500px',
        height: '500px',
        margin: '10vh 0'
    }
};
export default styles;